import React from "react";
import { connect } from "react-redux";
import { Text } from "react-internationalization";
import ContactUs from "./Contact";
import PlanTitle from "./PlanTitle";
const subHeader = (header) => {
  let subHedar = "";
  subHedar = (
    <React.Fragment>
      <PlanTitle />
      <ContactUs />
    </React.Fragment>
  );
  if (header === "INDIVIDUAL") {
    return subHedar;
  } else if (header === "RETIREE") {
    return (
      <React.Fragment>
        <PlanTitle />
        <div 
        // className="pull-left"
        >
          <Text id="header.planSDPEBASubPara" />
        </div>
      </React.Fragment>
    );
  } else {
    return subHedar;
  }
};

const CUSTOMER_LOGO2 = {
  INDIVIDUAL: subHeader("INDIVIDUAL"),
  GROUP: subHeader("GROUP"),
  RETIREE: subHeader("RETIREE"),
};

const CUSTOMER_LOGO = (props) => {
  return (
    <React.Fragment>
      {CUSTOMER_LOGO2[props.productCategory]
        ? CUSTOMER_LOGO2[props.productCategory]
        : null}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedPlan: state.login.selectedPlanName
      ? state.login.selectedPlanName
      : state.webApp.preEnrollInfo?.planName,
    productCategory: state.login.productCategory
      ? state.login.productCategory
      : state.webApp.preEnrollInfo?.productCategory,
    year: state.webApp.year.planYear,
    lang: state.webApp.language,
  };
};

export default connect(mapStateToProps)(CUSTOMER_LOGO);
